import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { LanguageService } from '../../language.service'

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
	const languageService = inject(LanguageService)
	const reqWithHeaders = req.clone({
		headers: req.headers.append('Accept-Language', languageService.currentLanguage()),
	})
	return next(reqWithHeaders)
}
